var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIslam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 11.5373 21.3065 11.4608 21.0672 11.8568C19.9289 13.7406 17.8615 15 15.5 15C11.9101 15 9 12.0899 9 8.5C9 6.13846 10.2594 4.07106 12.1432 2.93276C12.5392 2.69347 12.4627 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1411 2.24522C17.2784 1.91826 17.7216 1.91826 17.8589 2.24522L18.8577 4.62313C18.9146 4.7586 19.0368 4.85152 19.1774 4.8663L21.6466 5.12579C21.9861 5.16147 22.123 5.60264 21.8684 5.8404L20.0165 7.56952C19.911 7.66803 19.8644 7.81836 19.8944 7.96297L20.4216 10.5013C20.4941 10.8503 20.1356 11.1229 19.8409 10.9429L17.6976 9.63365C17.6366 9.59636 17.5683 9.57771 17.5 9.57771C17.4317 9.57771 17.3634 9.59636 17.3024 9.63365L15.1591 10.9429C14.8644 11.1229 14.5059 10.8503 14.5784 10.5013L15.1056 7.96297C15.1356 7.81836 15.089 7.66803 14.9835 7.56952L13.1316 5.8404C12.877 5.60264 13.0139 5.16147 13.3534 5.12579L15.8226 4.8663C15.9632 4.85152 16.0854 4.7586 16.1423 4.62313L17.1411 2.24522Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIslam);
export default __webpack_public_path__ + "static/media/islam.1a987f572710617c28c4f9dbf3f73cf0.svg";
export { ForwardRef as ReactComponent };